var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row row light flex items-center tw-mb-1" }, [
      _c("label", { staticClass: "col-4" }, [
        _vm._v(
          _vm._s(_vm.$t("home.widgets.list.icat01_attributes.sound_mute"))
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-label col text-mono " }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.accesory.sound_mute
                ? _vm.$t("watches.activated")
                : _vm.$t("watches.deactivated")
            ) +
            "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-row row light flex items-center tw-mb-1" }, [
      _c("label", { staticClass: "col-4" }, [
        _vm._v(
          _vm._s(_vm.$t("home.widgets.list.icat01_attributes.tension_level"))
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-label col text-mono" }, [
        _c("span", { staticClass: "fa fa-bolt" }),
        _vm._v("\n      " + _vm._s(_vm.accesory.tension_level) + "\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }